exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flip-list-move{transition:transform .5s}.no-move{transition:transform 0s}.ghost{border-left:2px solid #00f;opacity:.5;background:#c8ebfb}.latest{width:20px;height:20px;margin-right:8px}.latest-bulb{color:orange!important}.truncated{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
